import { useEffect as $Vsl8o$useEffect } from "react";

function $9daab02d461809db$var$hasResizeObserver() {
  return typeof window.ResizeObserver !== 'undefined';
}

function $9daab02d461809db$export$683480f191c0e3ea(options) {
  var ref = options.ref,
      onResize = options.onResize;
  (0, $Vsl8o$useEffect)(function () {
    var element = ref === null || ref === void 0 ? void 0 : ref.current;
    if (!element) return;

    if (!$9daab02d461809db$var$hasResizeObserver()) {
      window.addEventListener('resize', onResize, false);
      return function () {
        window.removeEventListener('resize', onResize, false);
      };
    } else {
      var resizeObserverInstance = new window.ResizeObserver(function (entries) {
        if (!entries.length) return;
        onResize();
      });
      resizeObserverInstance.observe(element);
      return function () {
        if (element) resizeObserverInstance.unobserve(element);
      };
    }
  }, [onResize, ref]);
}

export { $9daab02d461809db$export$683480f191c0e3ea as useResizeObserver };